import React, { useRef, useEffect, useState, useMemo } from 'react';

import { useRouteMatch, useLocation } from 'react-router-dom';

import { lockWindow } from '../../utils/methods';
import './index.scss';
import { Facebook_Fill, Instagram, Youtube } from '../Icons';
import Link from '../Link';

const Header = ({ wording }) => {
  const _w = wording;

  const header = useRef(null);
  const location = useLocation();
  let prevScrollpos = 0;
  const [open, setOpen] = useState(false);
  const [headerMinimal, setHeaderMinimal] = useState(false);

  const needCustomHeader = useMemo(() => {
    const paths = ["/blog/", "/project/"];
    let result = false;
    paths.forEach((path) => {
      if (location.pathname.includes(path)) {
        result = true;
      }
    });

    return result;
  }, [location]);



  useEffect(() => {
    lockWindow(open)
  }, [open]);


  useEffect(() => {
    window.addEventListener('scroll', handleWatchScroll);
    return () => {
      window.removeEventListener('scroll', handleWatchScroll);
    };
  }, []);

  const handleWatchScroll = (e) => {
    const currentScrollPos = window.pageYOffset;
    const currentHeaderMinmal = currentScrollPos > prevScrollpos && currentScrollPos > 0;
    prevScrollpos = currentScrollPos;
    setHeaderMinimal(currentHeaderMinmal);
  };

  const homePageMatcher = useRouteMatch({ path: '/' });

  return (
    <React.Fragment>
      {needCustomHeader === false && (
        <div className={`main-header ${headerMinimal ? '-min' : ''} ${(homePageMatcher && homePageMatcher.isExact) ? '-clean' : ''}`} ref={header}>
          <div className="header">
            <div className="wrapper">
              <Link className="logo" to="/">
                <img src="/images/header-logo.svg" alt="" />
              </Link>
              <div className="header__list">
                <div className="menu">
                  {Object.values(_w.link).map((link, id) => (
                    <Link className={`link type-text -en -md menu__link ${link.link === location.pathname ? "is--active" : ""}`} key={id} to={link.link}>
                      <span>{link.label_en}</span>
                      <span>{link.label}</span>
                    </Link>
                  ))}
                </div>
                <div className="social">
                  <a className="menu__link" href={_w.sns.facebook} target="_blank" rel="noopener">
                    <Facebook_Fill />
                  </a>
                  <a className="menu__link" href={_w.sns.instagram} target="_blank" rel="noopener">
                    <Instagram />
                  </a>
                  <a className="menu__link" href={_w.sns.youtube} target="_blank" rel="noopener">
                    <Youtube />
                  </a>
                </div>
              </div>
              <div className={`board ${open ? '-active' : ''}`}>
                <button className="close" onClick={() => setOpen(false)}>
                  <i className="icon-arrow-left"></i>
                  <span>BACK</span>
                </button>
                <Link onClick={() => setOpen(false)} className="link type-heading -en -h2" to="/">Home</Link>
                {Object.values(_w.link).map((link, id) => <Link onClick={() => setOpen(false)} className="link type-heading -en -h2" key={id} to={link.link}>{link.label}</Link>)}

              </div>
              <button className="toggle"
                onClick={() => setOpen(true)}
              ><i className="icon-menu"></i></button>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

export default Header;